import { render } from "./CustomerDashboardItem.vue?vue&type=template&id=791071a9"
import script from "./CustomerDashboardItem.vue?vue&type=script&lang=js"
export * from "./CustomerDashboardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__